export const getAuthCode = async () => {
    let name = 'mako_auth';
    let cookieArr = document.cookie.split(";");
    for (let i = 0; i < cookieArr.length; i++) {
        let cookiePair = cookieArr[i].trim();
        // Check if this cookie starts with the name we want
        if (cookiePair.startsWith(name + "=")) {
            return cookiePair.substring(name.length + 1);
        }
    }

    return null; // If the cookie is not found
}